import Meter from "components/Meter";
import { formatCompactCurrency } from "utils/currency";

import styles from "./TotalPipelineModal.module.scss";

const UNSCORED_LABEL = "Unscored";
const SCORE_MAX = 100;
const SCORE_BAR_HEIGHT = 8;

export const createColumns = () => [
  {
    header: "Opportunity",
    accessorKey: "opportunityName",
    id: "opportunityName",
    enableSorting: false,
    cell: ({ row }) => (
      <span title={row.original.opportunityName}>
        {row.original.opportunityName}
      </span>
    ),
  },
  {
    header: "Agency",
    accessorKey: "agency",
    id: "agency",
    enableSorting: false,
    cell: ({ row }) => (
      <span title={row.original.agency}>{row.original.agency}</span>
    ),
  },
  {
    header: "Business alignment",
    accessorKey: "bestFitScore",
    id: "bestFitScore",
    enableSorting: false,
    cell: ({ row }) => {
      if (!row.original.scored) {
        return (
          <span className={styles.totalPipelineModal__unscored}>
            {UNSCORED_LABEL}
          </span>
        );
      }
      return (
        <div className={styles.totalPipelineModal__alignmentCell}>
          <div className={styles.totalPipelineModal__alignmentBar}>
            <Meter
              id={`total-pipeline-score-${row.original.opportunityId}`}
              max={SCORE_MAX}
              showLabel={false}
              size={SCORE_BAR_HEIGHT}
              value={row.original.bestFitScore}
            />
          </div>
          <span className={styles.totalPipelineModal__scoreCell}>
            {row.original.bestFitScore}
          </span>
        </div>
      );
    },
  },
  {
    header: "Pipeline value",
    accessorKey: "pipelineValue",
    id: "pipelineValue",
    enableSorting: false,
    cell: ({ row }) => (
      <span>
        {formatCompactCurrency(
          row.original.pipelineValue,
          row.original.currency
        )}
      </span>
    ),
  },
];
